import { createActionGroup } from '@ngrx/store';

import { payload } from 'ish-core/utils/ngrx-creators';

export const accountNavigationFavoritesActions = createActionGroup({
  source: 'Account Navigation Favorites',
  events: {
    /** adds the navigation item to the favorites or removes it if it is a favorite already */
    'Toggle Account Navigation Favorite': payload<{ id: string }>(),
    /** takes over the favorites of the user profile, the single source of truth */
    'Sync Account Navigation Favorites': payload<{ favoriteIds: string[] }>(),
  },
});
